import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const PPTStoryline = ({ slides = [] }) => {
  const [copiedIdx, setCopiedIdx] = useState(null);

  const onCopy = async (slide, idx) => {
    const text = `Slide ${slide.slide || idx + 1}: ${slide.title}\n\n${slide.content}`;
    try {
      await navigator.clipboard.writeText(text);
      setCopiedIdx(idx);
      toast.success(`Slide ${idx + 1} copied`);
      setTimeout(() => setCopiedIdx(null), 1500);
    } catch {
      toast.error("Copy failed");
    }
  };

  const onCopyAll = async () => {
    const text = slides.map((s, i) => `SLIDE ${s.slide || i + 1}: ${s.title}\n${s.content}`).join("\n\n---\n\n");
    try {
      await navigator.clipboard.writeText(text);
      toast.success("All slides copied");
    } catch {
      toast.error("Copy failed");
    }
  };

  if (!slides || slides.length === 0) {
    return <div className="text-[#525252] text-sm">No slides</div>;
  }

  return (
    <div data-testid="ppt-storyline">
      <div className="flex items-center justify-between mb-3">
        <div className="kpi-label">{slides.length} slides · sales meeting deck</div>
        <button
          type="button"
          onClick={onCopyAll}
          data-testid="copy-all-slides-btn"
          className="h-8 px-3 rounded-sm bg-transparent hover:bg-[#1F1F1F] text-white border border-[#262626] hover:border-[#404040] flex items-center gap-2 transition-colors text-xs font-mono-data tracking-wider uppercase"
        >
          <Copy className="w-3 h-3"/> Copy all
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {slides.map((s, idx) => (
          <div
            key={idx}
            data-testid={`slide-${idx}`}
            className="group relative bg-[#141414] border border-[#262626] rounded-sm overflow-hidden hover:border-[#404040] transition-colors"
          >
            <div className="aspect-[16/10] p-5 flex flex-col">
              <div className="flex items-center justify-between mb-3">
                <div className="kpi-label text-[#0A84FF]">SLIDE · {String(s.slide || idx + 1).padStart(2, "0")}</div>
                <button
                  type="button"
                  onClick={() => onCopy(s, idx)}
                  className="opacity-0 group-hover:opacity-100 transition-opacity p-1.5 rounded-sm hover:bg-[#1F1F1F] text-[#737373] hover:text-white"
                  aria-label="Copy slide"
                  data-testid={`copy-slide-${idx}`}
                >
                  {copiedIdx === idx ? <Check className="w-3.5 h-3.5 text-[#32D74B]"/> : <Copy className="w-3.5 h-3.5"/>}
                </button>
              </div>
              <h4 className="font-display text-lg text-white tracking-tight mb-2 leading-tight">{s.title}</h4>
              <p className="text-sm text-[#A3A3A3] leading-relaxed flex-1 overflow-y-auto">{s.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PPTStoryline;
